import * as React from "react";
import { Modal, Spin, Button } from "antd";
import "./ExpenseCommentModal.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSync } from "@fortawesome/free-solid-svg-icons";
import { ViewExpenseCommentsButton } from '../Buttons/ViewExpenseCommentsButton/ViewExpenseCommentsButton';

interface IExpenseCommentModalProps {
  expenseId: number;
  onRefresh: () => void;
  loading: boolean;
  showStartView: boolean;
  showModal: boolean;
  onClose: () => void;
  onViewMessages: () => void;
}

export const ExpenseCommentModal: React.FC<IExpenseCommentModalProps> = ({
  expenseId,
  children,
  onRefresh,
  loading,
  showStartView,
  showModal,
  onClose,
  onViewMessages
}) => {
  return (
    <>
      <Modal
        className="modal-contact-requests"
        title={`Histórico de atualizações ${expenseId}`}
        visible={showModal}
        onCancel={onClose}
        footer={[
          showStartView &&
          <Button key="sync-button" disabled={loading} type="default" onClick={() => onRefresh()}>
            <FontAwesomeIcon icon={faSync} />
          </Button>
        ]}
      >
        <ViewExpenseCommentsButton onChange={onViewMessages} />
        <Spin spinning={loading} tip="Carregando">
          {children}
        </Spin>
      </Modal>
    </>
  );
};



// WEBPACK FOOTER //
// ./src/components/common/ExpenseComments/Modal/ExpenseCommentModal.tsx